(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.zhCN = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    md: {
      action_sheet: {
        cancel: '取消'
      },
      captcha: {
        sendCaptcha: '发送验证码',
        countdown: '{$1}s 后重发'
      },
      cashier: {
        payCash: '\u652F\u4ED8\u91D1\u989D(\u5143)',
        confirmPay: '\u786E\u5B9A\u652F\u4ED8',
        morePayWays: '\u66F4\u591A\u652F\u4ED8\u65B9\u5F0F',
        pay: '\u652F\u4ED8',
        payResultSearch: '\u652F\u4ED8\u7ED3\u679C\u67E5\u8BE2\u4E2D...',
        paySuccess: '\u652F\u4ED8\u6210\u529F',
        payFail: '\u652F\u4ED8\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5',
        confirm: '\u6211\u77E5\u9053\u4E86'
      },
      date_picker: {
        year: '年',
        month: '月',
        day: '日',
        hour: '时',
        minute: '分'
      },
      dialog: {
        confirm: '确定',
        cancel: '取消'
      },
      number_keyboard: {
        confirm: '确定'
      },
      picker: {
        confirm: '确认',
        cancel: '取消'
      },
      result_page: {
        networkError: '\u7F51\u7EDC\u8FDE\u63A5\u5F02\u5E38',
        noInformation: '\u6682\u65E0\u4FE1\u606F',
        lostWay: '\u60A8\u8981\u8BBF\u95EE\u7684\u9875\u9762\u5DF2\u4E22\u5931'
      },
      scroll_view: {
        more: {
          loading: '更多加载中...',
          allLoaded: '全部已加载'
        },
        refresh: {
          pullDownRefresh: '下拉刷新',
          freedRefresh: '释放刷新',
          refreshing: '刷新中...'
        }
      },
      selector: {
        cancel: '取消'
      },
      tab_picker: {
        choose: '请选择'
      }
    }
  };
});